import React, {Fragment} from 'react';
import { Link } from 'react-router-dom';

const BlogItemTwo = [
    {
        img: 'additional1.png',
        meta: '3 Apr, 2021',
        title: `Engineering & intergration.`,
        text: 'Discover more',
        icon: 'fas fa-chevron-right',
        className: '',
        fadeUp: 'fade-up',
        dataDelay: ''
    }, {
        img: 'additional2.png',
        meta: '23 Apr, 2021',
        title: `Business & Sales Process Analysis`,
        text: 'Discover more',
        icon: 'fas fa-chevron-right',
        className: '',
        fadeUp: 'fade-up',
        dataDelay: '100'
    }
]

{/*
 {
    img: 'blog_img_06',
    meta: '3 Apr, 2021',
    title: `A discount cartridge dsu is better ever.`,
    text: 'Discover more',
    icon: 'fas fa-chevron-right',
    className: '',
    fadeUp: 'fade-up',
    dataDelay: '200'
}
*/}

const BlogTwo = () => {
    return (
        <Fragment>
            <div className="row gx-xxl-5">
                {BlogItemTwo.map((val, i) => (
                    <div key={i} className={`col-lg-4 col-sm-6 d-flex ${val.className}`} data-aos={val.fadeUp} data-aos-delay={val.dataDelay}>
                        <article className="blog-meta-two mt-30">
                            <figure className="post-img m0">
                                <Link to="/contact" className="w-100 d-block"><img src={`images/assets/${val.img}`} alt="" className="w-100 tran4s"/></Link>
                            </figure>
                            <div className="post-data">
                                <div className="post-tag">
                                    <Link to="/contact">{val.meta}</Link>
                                </div>
                                <Link to="/contact" className="blog-title">
                                    <h5>{val.title}</h5>
                                </Link>
                                <Link to="/contact" className="read-btn tran3s">{val.text} <i className={val.icon}/></Link>
                            </div>
                            {/* /.post-data */}
                        </article>
                    </div>
                ))}
            </div>
        </Fragment>
    )
}

export default BlogTwo